import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=50abef2b&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=50abef2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50abef2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50abef2b')) {
      api.createRecord('50abef2b', component.options)
    } else {
      api.reload('50abef2b', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=50abef2b&scoped=true&", function () {
      api.rerender('50abef2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KXMEmhPpqR6W/JS/comp/SearchFilterTokens.vue"
export default component.exports